import React, { useEffect, useState } from 'react';
import { Layout, BlockStack, Box, Text, Card, TextField, InlineGrid, FormLayout, useBreakpoints, Divider } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { getSettingAsync } from '../../redux/setting';
import { getAllSetting } from '../../redux/setting/slice';
import Placeholder from '../common/Placeholder';
import LoadingComponent from '../common/Loading';
import { extractDate } from '../../utils';

const GeneralAndAccount = () => {
    const { smUp } = useBreakpoints();
    const dispatch = useDispatch();
    const { settingData, isSettingLoading } = useSelector(getAllSetting);
    const [storeName, setStoreName] = useState('store name');
    const [storeEmail, setStoreEmail] = useState('store email');
    const [storeCurrency, setStoreCurrency] = useState('store currency');
    const [storeCountry, setStoreCountry] = useState('store country');
    const [installDate, setInstallDate] = useState('Monday 5 May');
    const [selectedPlan, setSelectedPlan] = useState('Basic Plan');
    const [configuredVariantCount, setConfiguredVariantCount] = useState(10);

    useEffect(() => {
        dispatch(getSettingAsync());
    }, []);

    useEffect(() => {
        if (settingData) {
            setStoreName(settingData.shop_name);
            setStoreEmail(settingData.email);
            setStoreCurrency(settingData.currency);
            setStoreCountry(settingData.country_name);
            setConfiguredVariantCount(settingData.configured_variant);
            setInstallDate(extractDate(settingData.created_on, false));
        }
    }, [settingData]);

    if (isSettingLoading) {
        return <LoadingComponent />;
    }

    return (
        <Layout.Section>
            <BlockStack gap={{ xs: "800", sm: "400" }}>
                <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                    <Box
                        as="section"
                        paddingInlineStart={{ xs: 400, sm: 0 }}
                        paddingInlineEnd={{ xs: 400, sm: 0 }}
                    >
                        <BlockStack gap="400">
                            <Text as="h3" variant="headingMd">
                                Store Information
                            </Text>
                            <Text as="p" variant="bodyMd">
                                Configure your store information.
                            </Text>
                        </BlockStack>
                    </Box>
                    <Card>
                        <BlockStack gap="400">
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Store Name"
                                    value={storeName}
                                    onChange={(value) => setStoreName(value)}
                                    readOnly={true}
                                />
                                <TextField
                                    label="Store Email"
                                    value={storeEmail}
                                    onChange={(value) => setStoreEmail(value)}
                                    readOnly={true}
                                />
                            </FormLayout.Group>
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Store Currency"
                                    value={storeCurrency}
                                    onChange={(value) => setStoreCurrency(value)}
                                    readOnly={true}
                                />
                                <TextField
                                    label="Store Country"
                                    value={storeCountry}
                                    onChange={(value) => setStoreCountry(value)}
                                    readOnly={true}
                                />
                            </FormLayout.Group>
                        </BlockStack>
                    </Card>
                </InlineGrid>
            </BlockStack>
            <Placeholder />
            {smUp ? <Divider /> : null}
            <Placeholder />
            <BlockStack gap={{ xs: '800', sm: '400' }}>
                <InlineGrid columns={{ xs: '1fr', md: '2fr 5fr' }} gap="400">
                    <Box
                        as="section"
                        paddingInlineStart={{ xs: 400, sm: 0 }}
                        paddingInlineEnd={{ xs: 400, sm: 0 }}
                    >
                        <BlockStack gap="400">
                            <Text as="h3" variant="headingMd">
                                App Installation Details
                            </Text>
                            <Text as="p" variant="bodyMd">
                                Information about your app installation and configuration settings.
                            </Text>
                        </BlockStack>
                    </Box>

                    <Card>
                        <BlockStack gap="400">
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Install Date"
                                    value={installDate}
                                    readOnly
                                />
                                <TextField
                                    label="Selected Plan"
                                    value={selectedPlan}
                                    readOnly
                                />
                                <TextField
                                    label="Configured Variant"
                                    value={configuredVariantCount}
                                    readOnly
                                    suffix='/ variants'
                                />
                            </FormLayout.Group>
                        </BlockStack>
                    </Card>
                </InlineGrid>
            </BlockStack>
        </Layout.Section>
    );
};

export default GeneralAndAccount;
